<!-- Progress bar -->
<div *ngIf="showSurvey"
     class="progress bg-primary"
     style="position: fixed; top: 0; left: 0; width: 100%; height: 5px; z-index: 1050;">
  <div class="progress-bar bg-light"
       role="progressbar"
       [style.width.%]="progressPercent"
       aria-valuemin="0"
       aria-valuemax="100">
  </div>
</div>

<div class="survey-active fullscreen-center">
  <div class="container d-flex justify-content-center">

    <!--Top right logo-->
    <img *ngIf="showSurvey || isSubmitted" src="assets/images/IFSLogoV2.png" alt="IFS Logo" class="page-logo">

    <!-- Landing Page -->
    <div *ngIf="!showSurvey && !isSubmitted" class="text-center">
      <img src="assets/images/IFSLogoV2.png" alt="IFS Logo" class="start-up-logo">

      <div class="slide-in-up mt-5">
        <p class="fs-2 mb-2">Welcome to the catering survey for {{survey?.shipName}}</p>
        <p class="fs-5 mb-4 text-muted">This will only take up a bit of your time. Your feedback is appreciated.</p>
        <button class="btn btn-light btn-lg text-warning fw-bold px-4" (click)="startSurvey()">Start</button>
      </div>

    </div>

    <!-- Survey Questions -->
    <div *ngIf="showSurvey" class="question-container slide-in-up">
      <div *ngFor="let question of survey.questions; let idx = index;">
        <div *ngIf="currentIndex == idx" class="d-flex justify-content-center">
          <div class="row question bg-primary" [ngClass]="direction">
            <div class="col-1 text-end"><span class="fs-5">{{idx + 1}}</span></div>
            <div class="col-11">

              <!-- Question -->
              <p class="fs-3 text-start">{{question.onBoardSurveyQuestion}}</p>

              <!-- Rating -->
              <div class="mb-4 ms-1 row" *ngIf="question.questionType === 'Rating'">

                <div class="rating-box" *ngFor="let option of ratingOptions"
                     [class.selected]="question.answerRating === option.value"
                     (click)="selectRating(question, option.value, selectedRating)" #selectedRating>

                  <!-- Check mark -->
                  <div class="corner-check" *ngIf="question.answerRating === option.value">
                    <i class="feather icon-check text-primary"></i>
                  </div>

                  <!-- Smiley face image -->
                  <img [src]="option.image" alt="option.label" class="smiley-img">

                  <!-- Label -->
                  <span class="d-block" [ngClass]="{ 'fw-bolder': question.answerRating === option.value }">{{ option.label }}</span>
                </div>

              </div>

              <!-- Text Answer -->
              <div *ngIf="question.questionType === 'Text'" class="mb-4">
                <textarea [(ngModel)]="question.answerText"
                          rows="1"
                          class="answer-textarea"
                          oninput="this.style.height = ''; this.style.height = this.scrollHeight + 'px'"
                          placeholder="Type your answer here..."
                          noUnsafeSpecial></textarea>
              </div>

              <!-- Options -->
              <div *ngIf="question.optionsList?.length > 0" class="mb-4">
                <div class="rating-box" *ngFor="let option of question.optionsList"
                     [class.selected]="question.answerOptionID === option.onBoardSurveyQuestionOptionID"
                     (click)="selectOption(question, option.onBoardSurveyQuestionOptionID, selectedOption)" #selectedOption>

                  <!-- Check mark -->
                  <div class="corner-check" *ngIf="question.answerOptionID === option.onBoardSurveyQuestionOptionID">
                    <i class="feather icon-check text-primary"></i>
                  </div>

                  <!-- Label -->
                  <span class="d-block" [ngClass]="{ 'fw-bolder': question.answerOptionID === option.onBoardSurveyQuestionOptionID }">{{ option.optionText }}</span>
                </div>
              </div>

              <!-- Submit -->
              <div *ngIf="currentIndex === survey.questions.length - 1" class="position-absolute">
                <button class="btn btn-light btn-lg text-warning fw-bold px-4" (click)="submit()">Submit</button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Survey Navigation Buttons -->
    <div *ngIf="showSurvey" class="position-fixed bottom-0 w-100 d-flex justify-content-end mb-4 me-4">

      <!-- Validation summary -->
      <div id="validationSummary" *ngIf="errorMessageList.length > 0" class="alert alert-danger error-message">
        <div *ngFor="let errorMessage of errorMessageList">
          <i class="feather icon-alert-triangle me-1"></i>{{errorMessage}}
        </div>
      </div>

      <div [style.visibility]="survey.questions.length > 1 ? 'visible' : 'hidden'">
        <button class="btn btn-light text-warning px-4 fs-4 fa fa-angle-up me-1"
                [disabled]="currentIndex === 0"
                (click)="prev()"></button>

        <button class="btn btn-light text-warning px-4 fs-4 fa fa-angle-down"
                [disabled]="currentIndex === survey.questions.length - 1"
                (click)="next()" #nextBtn></button>
      </div>
    </div>

    <!-- Submitted -->
    <div *ngIf="isSubmitted" class="text-center">

      <div class="slide-in-up">
        <p class="fs-2 mb-4">Thank you for your feedback.</p>
        <button class="btn btn-light btn-lg text-warning fw-bold px-4" (click)="reload()">Reload</button>
      </div>

    </div>

  </div>
</div>
